import { 
    BRANDKIT_INITIATE_ICONS_UPLOAD, BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR, BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS, 
    BRANDKIT_UPLOAD_ICONS_REQUEST, BRANDKIT_UPLOADING_ICONS_SUCCEEDED, BRANDKIT_UPLOADING_ICONS_FAILED,
    BRANDKIT_SEARCH_ICONS_REQUEST, BRANDKIT_SEARCHING_ICONS_SUCCEEDED, BRANDKIT_SEARCHING_ICONS_FAILED, 
    BRANDKIT_DELETE_ICONS_REQUEST, BRANDKIT_DELETING_ICONS_SUCCEEDED, BRANDKIT_DELETING_ICONS_FAILED, 
    BRANDKIT_INVALIDATE_ICONS_LIBRARY, BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR
  } from 'constants/actionTypes';
    
    import _ from 'lodash';
    
    const initialState = {
      loading: false,
      fetched: false,
      invalidated: false,
      errorType: null,
      items: [],
      pagination: {
        currentPage: 0,
        totalPages: 0,
      },
      uploads: [],
    }
    
    export function brandKitIconsReducer(state = initialState, action) {
      switch (action.type) {
    
        case BRANDKIT_INITIATE_ICONS_UPLOAD: {
          const request = action.payload;
          const {type,size} = request;
          const formats = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/bmp', 'image/gif', 'image/svg+xml', 'video/mp4']
          if(type==='video/mp4' && size > 15) {
            return {
              ...state,
              uploadError:true,
              errorType: 'The video size should be less than 15mb.',
            };
          }
          if(!formats.includes(type)) {
            return {
              ...state,
              uploadError:true,
              errorType: 'Unsupported file format.',
            };
          }
          var uploads = [...state.uploads, request];
          uploads = _.uniqBy(uploads, 'id');
    
          return {
            ...state,
            uploads: uploads,
          }
        }
    
        case BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR: {
          return {
            ...state,
            uploadError: false,
          }
        }
    
        case BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS: {
          const { id, progress } = action.payload;
    
          var uploads = state.uploads.map(icon => {
            if (icon.id === id) {
              return {
                ...icon,
                progress: progress,
              }
            }
    
            return icon;
          })
    
          return {
            ...state,
            uploads: uploads
          }
        }
    
        case BRANDKIT_UPLOAD_ICONS_REQUEST: {
          const { id } = action.payload;
    
          var uploads = state.uploads.map(icon => {
            if (icon.id === id) {
              return {
                ...icon,
                processing: true
              }
            }
            return icon;
          })
    
          return {
            ...state,
            uploads: uploads,
          }
        }
    
        case BRANDKIT_UPLOADING_ICONS_SUCCEEDED: {
          const { id, response } = action.payload;
    
          var uploads = state.uploads.filter(icon => {
            return icon.id != id;
          });
    
          var items = [response, ...state.items];
          items = _.uniqBy(items, 'id');
          items = _.orderBy(items, 'createdDate', 'desc');
    
          return {
            ...state,
            uploads: uploads,
            items,
          }
        }
    
        case BRANDKIT_UPLOADING_ICONS_FAILED: {
          const { id, error } = action.payload;
    
          var uploads = state.uploads.map(icon => {
            if (icon.id === id) {
              return {
                ...icon,
                processing: false,
                error: error
              }
            }
    
            return icon;
          })
    
          return {
            ...state,
            uploads: uploads
          }
        } 
    
        case BRANDKIT_SEARCH_ICONS_REQUEST: {
          return {
            ...state,
              loading: true
            }
          }
    
        case BRANDKIT_SEARCHING_ICONS_SUCCEEDED: {
          const { records, ...pagination } = action.payload.response;
      
          if (pagination.currentPage !== 0) {
            items = [...state.items, ...records];
          } else {
            items = records;
          }
          
          items = _.uniqBy(items, 'id');
          
          return {
            ...state,
            loading: false,
            fetched: true,
            items: items,
            pagination: pagination
          }
        }
    
        case BRANDKIT_SEARCHING_ICONS_FAILED: {
          return {
            ...state,
            loading: false,
            error: action.payload
          }
        }
    
        case BRANDKIT_DELETE_ICONS_REQUEST: {
          return {
            ...state,
            deleting: true,
          }
        }
    
        case BRANDKIT_DELETING_ICONS_SUCCEEDED: {
          const { ids, response } = action.payload;
          
          const items = state.items.filter(item => (!(ids).includes(item.id)));
    
          return {
            ...state,
            loading: false,
            deleting: false,
            items: items,
          }
        }
    
        case BRANDKIT_DELETING_ICONS_FAILED: {
          return {
            ...state,
            loading: false,
            deleting: false,
            error: action.payload.error[0]
          }
        }
    
        case BRANDKIT_INVALIDATE_ICONS_LIBRARY: {
          return initialState;
        }
    
        case BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR:{
          return{
            ...state,
            error:false
          }
        }
    
        default:
          return state;
      }
    }